import { WidgetAnalyticsService } from './widget-analytics.service';
import * as i0 from "@angular/core";
import * as i1 from "./widget-analytics.service";
var WidgetAuthService = /** @class */ (function () {
    function WidgetAuthService(analyticsService) {
        this.analyticsService = analyticsService;
    }
    /**
     * Validates a developer's widget access.
     */
    WidgetAuthService.prototype.authDeveloper = function (analytic) {
        return this.analyticsService.sendAnalytic(analytic);
    };
    /**
     * Validate a user's widget access.
     */
    WidgetAuthService.prototype.authUser = function (analyticId) {
        return this.analyticsService.getAnalytic(analyticId);
    };
    WidgetAuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WidgetAuthService_Factory() { return new WidgetAuthService(i0.ɵɵinject(i1.WidgetAnalyticsService)); }, token: WidgetAuthService, providedIn: "root" });
    return WidgetAuthService;
}());
export { WidgetAuthService };
